/**
 * Gambian dalasi.
 */
export var GMD = {
  code: 'GMD',
  base: 10,
  exponent: 2
};